module.exports = __webpack_public_path__ + "img/jbd2.c52fc10e.webp";